import * as React from 'react';
import { Participant, SchoolEvent } from '../../../../../../models/event';
import { Button } from '../../../../../../components/Button/Button';
import { Field, Form, Formik } from 'formik';
import { VENUE_DISTANCE, VENUE_DISTANCE_SERVER_TO_CLIENT_MAPPING } from '../../../../../../consts/venue';
import * as Yup from 'yup';
import { Autocomplete } from '../../../../../../components/Autocomplete/Autocomplete';
import { getName, searchFunctionEventAddOrChangeSchool } from '../../../../../../helpers/autocomplete/autocomplete';
import { AppUser } from '../../../../../App/App';
import './SchoolEventChangeSchoolForm.scss';

interface Props {
  event: SchoolEvent;
  user: AppUser;
  participant: Participant;
  onCancel: () => void;
  onSubmit: (schoolId: string) => void;
}

interface State {
  distance: number;
}

const initialValues = {
  schoolId: '',
  school: undefined
};

const validationSchema = Yup.object().shape({
  schoolId: Yup.string().required('Required')
});

export class SchoolEventChangeSchoolForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      distance: VENUE_DISTANCE.UNLIMITED
    };
  }
  getSchools = (text: string) => {
    const { user, event } = this.props;
    const { distance } = this.state;

    return searchFunctionEventAddOrChangeSchool(text, user, event, distance);
  };

  render() {
    const { onCancel, onSubmit } = this.props;
    const { distance } = this.state;

    return (
      <div className="eChangeOpponentForm">
        <p className="eChangeOpponentForm__intro">Choose another school to invite to this event.</p>
        <div className="eChangeOpponentForm__field">
          <label className="eChangeOpponentForm__label">Maximum distance</label>
          <select
            value={distance}
            className="form-control eChangeOpponentForm__control"
            onChange={event => {
              this.setState({
                distance: Number(event.target.value)
              });
            }}
          >
            <option value={VENUE_DISTANCE.UNLIMITED}>{VENUE_DISTANCE_SERVER_TO_CLIENT_MAPPING.UNLIMITED}</option>
            <option value={VENUE_DISTANCE['10M']}>{VENUE_DISTANCE_SERVER_TO_CLIENT_MAPPING['10M']}</option>
            <option value={VENUE_DISTANCE['20M']}>{VENUE_DISTANCE_SERVER_TO_CLIENT_MAPPING['20M']}</option>
            <option value={VENUE_DISTANCE['30M']}>{VENUE_DISTANCE_SERVER_TO_CLIENT_MAPPING['30M']}</option>
            <option value={VENUE_DISTANCE['40M']}>{VENUE_DISTANCE_SERVER_TO_CLIENT_MAPPING['40M']}</option>
            <option value={VENUE_DISTANCE['50M']}>{VENUE_DISTANCE_SERVER_TO_CLIENT_MAPPING['50M']}</option>
          </select>
        </div>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={data => {
            const { schoolId } = data;
            onSubmit(schoolId);
          }}
        >
          {({ values, setFieldValue, touched, errors }) => (
            <Form>
              <div className="eChangeOpponentForm__field">
                <label className="eChangeOpponentForm__label">
                  School <span>*</span>
                </label>
                <Field name="participants">
                  {({ field }) => {
                    return (
                      <Autocomplete
                        searchFunction={this.getSchools}
                        getElementTitle={getName}
                        customClass="mFullWidth mb-3"
                        debounceMs={180}
                        defaultItem={values.school}
                        placeholder="Start typing the school name"
                        isItemWithImage={true}
                        onSelect={school => {
                          setFieldValue('school', school);
                          setFieldValue('schoolId', school.id);
                        }}
                      />
                    );
                  }}
                </Field>
                {touched.schoolId && errors.schoolId ? (
                  <div className="eChangeOpponentForm__error">{errors.schoolId}</div>
                ) : null}
              </div>

              <div className="eChangeOpponentForm__actions">
                <Button onClick={onCancel} text={'Cancel'} customClass={'btn-secondary eChangeOpponentForm__cancel'} />
                <button type="submit" className="btn eChangeOpponentForm__save">
                  Change opponent
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
}
